/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { TwistLoginRequest } from '../types/TwistLogin';
import type { TwistLoginResponse } from '../types/TwistLogin';

export type TwistLoginCreateRequest = TwistLoginRequest;
export type TwistLoginCreateResponse = TwistLoginResponse;

export type TwistLoginCreateQuery = {};

/**
 * POST /dmx-server/twist-login/
 *
 * ```yaml
 * operationId: twist_login_create
 * description: |-
 *   Takes a set of user credentials and returns an access and refresh JSON web
 *   token pair to prove the authentication of those credentials.
 * tags:
 *   - twist-login
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/TwistLogin'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/TwistLogin'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/TwistLogin'
 *   required: true
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/TwistLogin'
 *     description: ''
 * ```
 */
export const twistLoginCreateOperation = (rest?: TwistLoginCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/twist-login/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/twist-login/' };
  };

/**
 * POST /dmx-server/twist-login/
 *
 * ```yaml
 * operationId: twist_login_create
 * description: |-
 *   Takes a set of user credentials and returns an access and refresh JSON web
 *   token pair to prove the authentication of those credentials.
 * tags:
 *   - twist-login
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/TwistLogin'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/TwistLogin'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/TwistLogin'
 *   required: true
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/TwistLogin'
 *     description: ''
 * ```
 */
export const twistLoginCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: TwistLoginCreateQuery;
  request: TwistLoginRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<TwistLoginResponse>> => {
  const operation = twistLoginCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
